class CtaAnalytics {
  el;
  constructor(el) {
    this.el = el;

    this.bindListeners();
  }

  bindListeners() {
    this.el.addEventListener("click", this.dataPush.bind(this));
  }

  dataPush() {
    const itemName = this.el.querySelector('span:first-child').textContent.trim();
    const href = this.el.href;
    console.log(href);
    const path = window.location.pathname;
    const evento = {
      event: 'click_contact',
      page_path: path,
      item_nombre: itemName
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(evento);
    console.log('Evento enviado al dataLayer:', evento);
  }
}

const initCtaAnalytics = () => {
  const ctaBtns = document.querySelectorAll('.cta-banner .btn');

  ctaBtns?.forEach((btn) => {
    new CtaAnalytics(btn);
  })
}

initCtaAnalytics();